import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-slide-toggle-button',
  templateUrl: './slide-toggle-button.component.html',
  styleUrls: ['./slide-toggle-button.component.scss']
})
export class SlideToggleButtonComponent {
  @Input() status = false;
  @Input() config:{direction:'ltr'|'rtl'} = {direction:'rtl'};
  @Input() label:string|undefined;
  @Output() statusEmitter = new EventEmitter()

  changeStatus(){
    this.status = !this.status
    this.statusEmitter.emit(this.status)
  }
}
